import { FEATURE_FLAG_KEYS, type FeatureFlagKey } from "@asap/shared/constants/feature-flags";

export type FeatureFlags = Partial<Record<FeatureFlagKey, boolean>>;

export const seedFeatureFlags = (stored: FeatureFlags): FeatureFlags => {
  const next: FeatureFlags = { ...stored };
  for (const key of FEATURE_FLAG_KEYS) {
    if (next[key] === undefined) next[key] = true;
  }
  return next;
};
